var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"small":""},on:{"click":(e)=>_vm.copy(e, _vm.text)}},[_vm._v("mdi-content-copy")])
}
var staticRenderFns = []

export { render, staticRenderFns }